// extracted by mini-css-extract-plugin
export default {"refComments":"decisions_references-module__refComments--1oDgW"};